<template>
  <div class="assessment-container">
    <el-row>
      <el-col :span="isGeneralAdmin || hasFilter ? 12 : 24">
        <organization-breadcrumb :items="[$t('study_sets.curriculum'), $t('homework.assessment.title')]" />
      </el-col>
      <el-col v-if="isGeneralAdmin || hasFilter" :span="12">
        <admin-organization-switcher />
      </el-col>
    </el-row>
    <div class="content">
      <curriculum-menu :active-entry="`/organization/${currentOrganizationId}/assessments`" />
      <div class="table-wrapper">
        <elsa-tree
          accordion
          icon-class="tree-icon"
          :data="treeData"
          @assign="handleAssignToClass"
        >
          <template v-slot:title="{ node }">
            <span v-bind:class="node.data.options.titleClassArray">
              {{ node.data.label }}
            </span>
          </template>
        </elsa-tree>
      </div>
    </div>
    <add-assignment-wrapper
      ref="addAssignmentWrapper"
      :title="$t('study_sets.modals.addAssignment.assign_an_assessment')"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import AdminOrganizationSwitcher from "@/components/dashboard/AdminOrganizationSwitcher";
import CurriculumMenu from '@/components/studysets/CurriculumMenu';
import AddAssignmentWrapper from "@/components/modals/studysets/AddAssignmentWrapper";
import ElsaTree from "@/components/common/Tree";

export default {
  components: {
    OrganizationBreadcrumb,
    AdminOrganizationSwitcher,
    CurriculumMenu,
    AddAssignmentWrapper,
    ElsaTree
  },
  computed: {
    ...mapState("assignments", ["assessmentList"]),
    ...mapGetters("organization", [
      "isGeneralAdmin",
      "hasFilter",
      "currentOrganizationType",
      "currentOrganizationId",
      "isOrganizationAdmin",
      "isOrganizationTeacher",
    ]),
    treeData() {
      return this.assessmentList.map(item => {
        return {
          ...item,
          children: item.children.map(child => {
            return {
              ...child,
              options: {
                ...child.options,
                asignActionText: this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, `study_sets.assign_to_group`))
              }
            }
          })
        }
      })
    }
  },
  methods: {
    handleAssignToClass(node) {
      this.$refs.addAssignmentWrapper.handleAssignAssessmentToClass({ id: node.data.id, name: node.data.label } );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.assessment-container {
  width: 100%;
  .content {
    margin: 24px 40px;
    .assign-to-class {
      margin-right: 8px;

      button {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        padding: 8px 16px;
        border: 1px solid #007eff;
      }
    }
  }
}

</style>
